import { createUseStyles } from 'react-jss';

export default createUseStyles({
  form: {
    margin: 0,
  },
  hiddenSubmitButton: {
    display: 'none',
  },
});
